import React, { useEffect, useState } from 'react'
import Form from '../../Component/KYC/Form'
import { recruiterKycDetails } from '../../action/profile'
import { toast } from 'react-toastify';
import Loader from '../../Component/Common/Loader';

const KYC = () => {
    const [details, setDetails] = useState(null)
    const [showLoader, setShowLoader] = useState(false)

    useEffect(() => {
        setShowLoader(true);
        recruiterKycDetails()
            .then((res) => {
                if (res.status) {
                    setDetails(res.result);
                } else {
                    toast.error(res.error);
                }
            })
            .catch((error) => {
                console.error("Error fetching recruiter KYC details:", error);
                toast.error("An error occurred while fetching KYC details. Please try again.");
            })
            .finally(() => {
                setShowLoader(false);
            });
    }, []);



    return (
        <React.Fragment>
            {showLoader && <Loader />}
            <div className="container-fluid">
                <div className='row'>
                    <div className='col-md-12'>
                        {details && <Form
                            details={details}
                        />}
                    </div>
                </div>
            </div>

        </React.Fragment>
    )
}

export default KYC